import React from 'react';
import { Container, Flex, Heading, Text } from '@chakra-ui/react';
import MemberHeroSection from '@/components/membership/MemberHeroSection';

const linksData = [
  {
    id: 'aifs-1',
    date: '15th January 2025',
    text: 'IVCA Guidance on Draft Questionnaire for Due Diligence',
    link: 'https://static.levocdn.com/WGLBUT82/DraftQuestionnaireforDueDiligence-eg6wlkb2Lj9C.pdf',
  },
  {
    id: 'aifs-3',
    date: '09th October 2024',
    text: 'Implementation standards for specific due diligence of investors and investments of AIFs to prevent facilitation of circumvention through AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/ImplementationstandardsforspecificduediligenceofinvestorsandinvestmentsofAIFs-QsA24OOplQEP.pdf',
  },
  {
    id: 'aifs-2',
    date: '08th October 2024',
    text: 'SEBI Circular on Specific due diligence of investors and investments of AIFs',
    link: 'https://static.levocdn.com/WGLBUT82/SpecificduediligenceofinvestorsandinvestmentsofAIFs-VbXYm33Cuq5y.pdf',
  },
];

const InvestorSebiAifs = () => (
  <Flex direction="column" rowGap="20px">
    <MemberHeroSection
      title={
        <Heading
          as="h1"
          variant="headingText"
          color="text.headingWhite"
          fontSize={{ xs: '36px', sm: '60px', md: '74px' }}
          textAlign={{ xs: 'left', sm: 'left' }}
        >
          Specific due diligence of investors and investments of AIFs
        </Heading>
      }
      type="about-us"
    />
    <Container
      maxW="container.xl"
      pt={{ xs: '50px', md: '50px' }}
      pb={{ xs: '50px', md: '50px' }}
      as="section"
      id="info"
      scrollMarginTop="140px"
    >
      <Flex direction="column" gap="2">
        {linksData.map((item) => (
          <Flex
            key={item.id}
            direction={{ base: 'column', md: 'row' }}
            cursor="pointer"
            gap={{ md: '5' }}
            onClick={() => {
              window.open(item?.link, '_blank');
            }}
          >
            <Flex minWidth="200px">
              {item?.date ? (
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item?.date}
                </Text>
              ) : (
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item?.text}
                </Text>
              )}
              {item.date && (
                <Text
                  display={{ base: 'block', md: 'none' }}
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  :&nbsp;
                </Text>
              )}
            </Flex>
            {item.date && (
              <Flex>
                <Text
                  display={{ base: 'none', md: 'block' }}
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  :&nbsp;
                </Text>
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item.text}
                </Text>
              </Flex>
            )}
          </Flex>
        ))}
      </Flex>
    </Container>
  </Flex>
);

export default InvestorSebiAifs;
